import React, { useEffect, useState, useRef, useCallback } from "react";
import Webcam from "react-webcam";
import LoadingScreen from "../loadingScreen/LoadingScreen";
import { checkCameraPermission, detectBrowserFunction } from "../../utils/util";
import { videoConstraints } from "../../vars";
import CameraPermissionModal from "../cameraPermissionModal/CameraPermissionModal";

function CameraPermission({ setShowDrawer }) {
  const [showDeniedModal, setShowDeniedModal] = useState({ disabled: false, message: "" });
  const [loading, setLoading] = useState(true);
  const [browserName] = useState(detectBrowserFunction());
  const webcamRef = useRef();
  const handleCameraPermission = useCallback(async () => {
    const permission = await checkCameraPermission();
    setShowDeniedModal(permission);
    setLoading(false);
  },[]);
  useEffect(() => {
    handleCameraPermission();
  }, []);
  if (loading) {
    return <LoadingScreen className="h-full w-full desktop-wrapper fitViewScreen flex alignCenter justifyCenter" />;
  }
  if (showDeniedModal?.disabled) {
    return <CameraPermissionModal browserName={browserName} message={showDeniedModal?.message} />;
  }
  return (
    <Webcam
      audio={false}
      ref={webcamRef}
      screenshotQuality={1}
      videoConstraints={videoConstraints}
      mirrored
      onUserMedia={() => setShowDrawer(true)}
      screenshotFormat="image/jpeg"
      style={{
        position: "relative",
        top: 0,
        bottom: 0,
        zIndex: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  );
}

export default CameraPermission;
